import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getHomeScreenTiles,
  addHomeScreenTiles,
} from "../api/customHomeScreen";

export const fetchHomeScreenTiles = createAsyncThunk(
  "customHomeScreen/fetchHomeScreenTiles",
  async (params) => getHomeScreenTiles()
);

export const postHomeScreenTiles = createAsyncThunk(
  "customHomeScreen/addHomeScreenTiles",
  async (params) => addHomeScreenTiles(params?.tileList)
);

export const customHomeScreenSlice = createSlice({
  name: "customHomeScreen",
  initialState: {
    homeScreenTiles: null,
    loading: false,
  },
  extraReducers: {
    [fetchHomeScreenTiles.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchHomeScreenTiles.fulfilled]: (state, { payload }) => {
      state.homeScreenTiles = payload;
      state.loading = false;
    },
    [fetchHomeScreenTiles.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [postHomeScreenTiles.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [postHomeScreenTiles.fulfilled]: (state, { payload }) => {
      state.loading = false;
    },
    [postHomeScreenTiles.rejected]: (state, { payload }) => {
      state.loading = false;
    },
  },
});

export default customHomeScreenSlice.reducer;
